import { Level } from 'client/interfaces/IPuzzleCalendar'
import { useMemo } from 'react'
import usePuzzleType from './usePuzzleType'

/**
 * Returns the selected level ('basic', 'medium', etc) of the puzzle type.
 * @param puzzleTypeId
 * @returns
 */
const usePuzzleSelectedLevel = (puzzleTypeId: number): Level | '' => {
  const puzzleType = usePuzzleType(puzzleTypeId)

  const levelSelected = useMemo(() => {
    if (!puzzleType) {
      return ''
    }
    const { selectedLevel, levelRoles = [] } = puzzleType
    if (selectedLevel && levelRoles.some(({ level }) => level === selectedLevel)) {
      return selectedLevel
    }
    return levelRoles[0]?.level || ''
  }, [puzzleType])

  return levelSelected
}

export default usePuzzleSelectedLevel
